import React from 'react';
import {Col, Divider, InputNumber, Radio, Row, Slider} from 'antd';

import '../../asset/style/workflow/slot-component.css';
import {RegionSelectionConstants} from "../../redux_constants/region_selection.constant"
import ReactRegionSelect from 'react-region-select';
import {brushShape, brushType, scanSpeed, slideType, specimenType} from "../../utils/const";
import {store} from "../../helper/store";
import {onAddFocusPoint} from '../../redux_actions/preview_status.action';
import {drawCrossHair, specimenTypeOptions} from "./slot_component_utils";
import {IconButton} from "@mui/material";
import SquareTwoToneIcon from "@mui/icons-material/SquareTwoTone";
import CircleTwoToneIcon from "@mui/icons-material/CircleTwoTone";

export const getVerticalBrushPanel = (brushTypeVal, brushSize, onBrushToolChange, onBrushSizeChange, brushShapeVal, onBrushShapeChange) => {
    return [<Row key={0} style={{display: "flex", alignItems: "center", justifyContent: "center"}}>
        <IconButton onClick={() => onBrushShapeChange(brushShape.SQUARE)}>
            <SquareTwoToneIcon sx={{fontSize: 25, color: brushShapeVal === brushShape.SQUARE ? "black" : "gray"}}/>
        </IconButton>
        <IconButton onClick={() => onBrushShapeChange(brushShape.CIRCLE_S)}
                    disabled={brushTypeVal === brushType.ERASER}>
            <CircleTwoToneIcon
                sx={{
                    fontSize: 15,
                    color: brushTypeVal === brushType.ERASER ? "lightgray" : brushShapeVal === brushShape.CIRCLE_S ? "black" : "gray",
                }}/>
        </IconButton>
        <IconButton onClick={() => onBrushShapeChange(brushShape.CIRCLE_M)}
                    disabled={brushTypeVal === brushType.ERASER}>
            <CircleTwoToneIcon
                sx={{
                    fontSize: 25,
                    color: brushTypeVal === brushType.ERASER ? "lightgray" : brushShapeVal === brushShape.CIRCLE_M ? "black" : "gray"
                }}/>
        </IconButton>
        <IconButton onClick={() => onBrushShapeChange(brushShape.CIRCLE_L)}
                    disabled={brushTypeVal === brushType.ERASER}>
            <CircleTwoToneIcon
                sx={{
                    fontSize: 35,
                    color: brushTypeVal === brushType.ERASER ? "lightgray" : brushShapeVal === brushShape.CIRCLE_L ? "black" : "gray"
                }}/>
        </IconButton>
    </Row>
        , <div>
            <Divider></Divider>
            <Row key={1}>
                <Radio.Group style={{marginTop: "10px", marginBottom: "10px"}} size="small"
                             defaultValue={brushType.BRUSH} value={brushTypeVal} buttonStyle="solid"
                             className={"c240-button"}
                             onChange={onBrushToolChange}>
                    <Radio.Button value={brushType.REDRAW}
                                  style={{width: 100, textAlign: 'center'}}>Reset</Radio.Button>
                    <Radio.Button value={brushType.BRUSH} style={{width: 80, textAlign: 'center'}}>Brush</Radio.Button>
                    <Radio.Button value={brushType.ERASER}
                                  style={{width: 80, textAlign: 'center'}}>Eraser</Radio.Button>
                </Radio.Group>
            </Row>
        </div>,
        <Row key={1}>
            <Col>
                <Row className="arial-font" style={{fontSize: 13}}>
                    <Col span={12} style={{marginTop: 10}}>
                        <b>Brush / Eraser Size</b>
                    </Col>
                    <Col span={12}>
                        <Slider
                            defaultValue={brushSize}
                            onChange={onBrushSizeChange}
                            trackStyle={{backgroundColor: "#000000"}}
                            handleStyle={{borderColor: "#000000"}}
                            disabled={brushShapeVal !== brushShape.SQUARE}
                            max={50}
                            min={1}
                            style={{display: "inline-block", width: "120px"}}
                        />
                    </Col>
                </Row>
            </Col>
        </Row>
    ]
}

export const getSpeedPanel = (onScanSpeedChange, preview, currScanSpeed) => {
    return <Row>
        <Col span={24}>
            <Row>
                <Row className="arial-font" style={{fontSize: 13}}><b>Choose expected Artifact Level</b> (This will take
                    a normal scan)</Row>
                <Divider></Divider>
                <Row style={{marginTop: "10px", fontSize: 13}} className="arial-font">Defines tradeoff between scanning
                    speed and consistency of image quality</Row>
                <Radio.Group style={{marginTop: "10px", marginBottom: "10px"}} defaultValue={scanSpeed.MEDIUM}
                             className={"c240-button"}
                             value={(currScanSpeed || '').toUpperCase()} buttonStyle="solid"
                             onChange={onScanSpeedChange}
                             size="small"
                >
                    <Radio.Button value={scanSpeed.FAST} style={{width: 87, textAlign: 'center'}}>Minor</Radio.Button>
                    <Radio.Button value={scanSpeed.MEDIUM} style={{width: 87, textAlign: 'center'}}>Few</Radio.Button>
                    <Radio.Button value={scanSpeed.SLOW} style={{width: 87, textAlign: 'center'}}>Major</Radio.Button>
                </Radio.Group>
            </Row>
        </Col>
    </Row>
}

export const getBmaPanel = (isHemoLens, wbcCount, setWBCCount ) => {
    return <Col style={{margin:"0px 20px"}}>
                <Row className="arial-font" style={{fontSize:13}}><b>Choose expected {isHemoLens ? "WBCs. " : "FIELDs. "}</b></Row> 
                <Divider></Divider>

                <Row><b> {isHemoLens ? "# WBC: " : "# FIELD: "} </b>
                    <InputNumber min={1} max={5000} value={wbcCount} onChange={setWBCCount} />
                </Row>
                <Row className="arial-font" style={{fontSize: "13px"}}>
                    <span>One field on an average captures 10 viable WBCs for typical smears.</span> <br/>
                </Row>
                <Row className="arial-font" style={{fontSize: "13px"}}>
                    <span> ○  If you need 500 WBCs, we recommend setting {isHemoLens ? "# WBC: " : "# FIELD: "} to 70.</span> 
                </Row>
                <Row className="arial-font" style={{fontSize: "13px"}}>
                    <span> ○  You should be able to tune this parameter for your reporting protocol based on first few scans.</span> 
                </Row>
            </Col>
}

export const getStainChooser = (onSpecimenTypeChange, preview, specimenTypesToShow) => {
    return <Row>
        <Col span={24}>
            <Row>
                <Row className="arial-font" style={{fontSize: 13}}><b>Select Stain Type</b></Row>
                <Divider></Divider>
                <Row style={{marginTop: "10px", fontSize: 13}} className="arial-font">
                    <span>Auto-detects scanning area based on stain</span>
                </Row>
                <Radio.Group style={{marginTop: "10px", marginBottom: "10px"}} defaultValue={specimenType.HNE_TISSUE}
                             value={(preview.specimenType || '').toUpperCase()}
                             buttonStyle="solid"
                             className={"c240-button"}
                             onChange={onSpecimenTypeChange}
                             size="small"
                >
                    {specimenTypeOptions(specimenTypesToShow)}
                </Radio.Group>
            </Row>
        </Col>
    </Row>
}

export const getC240CanvasComponent = (status, previewCanvasRef, thresholdCanvasRef, brushEraserPrevCanvasRef, regions, onCanvasChange, allowPainting, 
    startPainting, paintCanvas, stopPainting, dropDistanceCanvas, dropDistanceCanvasRef, focusPointsCanvas, focusPointsCanvasRef, 
    preview, deviceId, brushTypeVal, showBrushOrEraserSize, rack, tray, slot, mySlideType=slideType.SLIDE_1_BY_3_INCH) => {

    const regionStyle = {
        background: 'rgba(255, 0, 0, 0)',
        zIndex: 1
    };

    let date = new Date();

    if (!Array.isArray(regions)) {
        regions = undefined;
    }

    let widthPreview = 60;
    if(mySlideType !== slideType.SLIDE_1_BY_3_INCH){
        widthPreview = 42;
    }

    return <Col>
        {brushTypeVal === brushType.REDRAW ?
            <ReactRegionSelect
                style={{zIndex: 1, width: `${widthPreview}vw`, height: "26vw", margin: 'auto', display: 'block'}}
                className="react-region-select-custom--style"
                maxRegions={1}
                regions={regions}
                regionStyle={regionStyle}
                constraint
                onChange={onCanvasChange}>
                <div id="scan-preview" className={mySlideType === slideType.SLIDE_1_BY_3_INCH ? "c240-preview-canvas-wrapper" : "c240-preview-canvas-wrapper-2by3"}>
                    <canvas ref={previewCanvasRef} className={mySlideType === slideType.SLIDE_1_BY_3_INCH ? "c240-region-selection-canvas-small" : "c240-region-selection-canvas-small-2by3"} />
                    <canvas id={"thresholdCanvas" + slot} ref={thresholdCanvasRef} className={mySlideType === slideType.SLIDE_1_BY_3_INCH ? "c240-region-selection-canvas-small" : "c240-region-selection-canvas-small-2by3"} />
                </div>
            </ReactRegionSelect> :
            // status ===  RegionSelectionConstants.CONFIRMED ?
            // <div>
            //     <img src={getOverlayedMaskForPath(slot + 1, tray, rack) + '?id=' + date.getTime()}
            //         style={{height: '192px', width: '576px'}}/>
            // </div> :
            status === RegionSelectionConstants.START_DROP_DISTANCE_SELECTION ?
            <div style={{ zIndex: 1 }} className={mySlideType === slideType.SLIDE_1_BY_3_INCH ? "c240-preview-canvas-wrapper" : "c240-preview-canvas-wrapper-2by3"}>
                <canvas ref={previewCanvasRef} className={mySlideType === slideType.SLIDE_1_BY_3_INCH ? "c240-region-selection-canvas-small" : "c240-region-selection-canvas-small-2by3"} />
                <canvas id={"thresholdCanvas" + slot}
                    ref={thresholdCanvasRef}
                    className={mySlideType === slideType.SLIDE_1_BY_3_INCH ? "c240-region-selection-canvas-small" : "c240-region-selection-canvas-small-2by3"} />
                <canvas id={"dropDistanceCanvas" + slot}
                    onMouseDown={(e) => drawCrossHair(e, dropDistanceCanvas, {clearCanvas: true, color: 'red', size: 10, width: 1}, preview, slot)}
                    ref={dropDistanceCanvasRef}
                    className={mySlideType === slideType.SLIDE_1_BY_3_INCH ? "c240-region-selection-canvas-small" : "c240-region-selection-canvas-small-2by3"} />
            </div> :
            status === RegionSelectionConstants.START_FOCUS_POINTS_SELECTION ?
            <div style={{ zIndex: 1 }} className={mySlideType === slideType.SLIDE_1_BY_3_INCH ? "c240-preview-canvas-wrapper" : "c240-preview-canvas-wrapper-2by3"}>
                <canvas ref={previewCanvasRef} className={mySlideType === slideType.SLIDE_1_BY_3_INCH ? "c240-region-selection-canvas-small" : "c240-region-selection-canvas-small-2by3"} />
                <canvas id={"thresholdCanvas" + slot}
                    ref={thresholdCanvasRef}
                    className={mySlideType === slideType.SLIDE_1_BY_3_INCH ? "c240-region-selection-canvas-small" : "c240-region-selection-canvas-small-2by3"} />
                <canvas id={"focusPointsCanvas" + slot}
                    onClick = {(e) => store.dispatch(onAddFocusPoint(e, deviceId, slot, preview, focusPointsCanvas))}
                    ref={focusPointsCanvasRef}
                    className={mySlideType === slideType.SLIDE_1_BY_3_INCH ? "c240-region-selection-canvas-small" : "c240-region-selection-canvas-small-2by3"} />
            </div> :
            <div style={{ zIndex: 1 }} className={mySlideType === slideType.SLIDE_1_BY_3_INCH ? "c240-preview-canvas-wrapper" : "c240-preview-canvas-wrapper-2by3"}>
                <canvas ref={previewCanvasRef} className={mySlideType === slideType.SLIDE_1_BY_3_INCH ? "c240-region-selection-canvas-small" : "c240-region-selection-canvas-small-2by3"} />
                <canvas id={"thresholdCanvas" + slot}
                    ref={thresholdCanvasRef}
                    className={mySlideType === slideType.SLIDE_1_BY_3_INCH ? "c240-region-selection-canvas-small" : "c240-region-selection-canvas-small-2by3"} />
                <canvas id={"brushEraserPrevCanvas" + slot} 
                    onMouseDown={allowPainting ? startPainting : undefined}
                    onMouseMove={allowPainting ? paintCanvas : showBrushOrEraserSize}
                    onMouseUp={allowPainting ? stopPainting : undefined}
                    ref={brushEraserPrevCanvasRef}
                    className={mySlideType === slideType.SLIDE_1_BY_3_INCH ? "c240-brush-eraser-prev-canvas-new" : "c240-brush-eraser-prev-canvas-new-2by3"} />
            </div>
        }
    </Col>
}

